import Model from '@/models/Model'

export class ModuleDataItem extends Model {

	public id!: number

	public defaults() {
		return {
			id: null,
			moduleName: '',
		}
	}

	public routes() {
		return {
			create: 'entries/{moduleName}',
			fetch: 'entries/{moduleName}/{id}',
			patch: 'entries/{moduleName}/{id}',
		}
	}

	public options() {
		return {
			patch: true,
		}
	}
}
